module.exports = ""


//////////////////
// WEBPACK FOOTER
// C:/Users/hyago/Desktop/SiteEventos/src/app/cbs/cbs.component.html
// module id = ../../../../../src/app/cbs/cbs.component.html
// module chunks = main